export function common() {
  // const header = document.getElementById("js-header");

  // const headerScroll = () => {
  //   window.addEventListener("scroll", () => {
  //     if (window.scrollY > 1 && window.innerWidth > 768) {
  //       header.classList.add("is-scroll");
  //     } else {
  //       header.classList.remove("is-scroll");
  //     }
  //   });
  // };

  // headerScroll();


  document.addEventListener('DOMContentLoaded', function () {
    // ハンバーガーメニュー
    document.querySelectorAll('.js-hamburger').forEach(function (hamburger) {
      hamburger.addEventListener('click', function () {
        this.classList.toggle('is-open');
        const drawer = document.querySelector('.js-drawer');
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    });

    // backgroundまたはページ内リンクをクリックで閉じる
    document.querySelectorAll('.js-drawer a[href]').forEach(function (link) {
      link.addEventListener('click', function () {
        closeDrawer();
      });
    });

    // resizeイベント
    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 768px)').matches) {
        closeDrawer();
      }
    });

    function openDrawer() {
      const drawer = document.querySelector('.js-drawer');
      drawer.classList.add('is-open');
      document.body.classList.add('body-no-scroll'); // スクロール禁止を追加
    }

    function closeDrawer() {
      const drawer = document.querySelector('.js-drawer');
      drawer.classList.remove('is-open');
      document.body.classList.remove('body-no-scroll'); // スクロール禁止を解除
    }
  });
}
